var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game_x"},[_c('h1',[_vm._v(_vm._s(_vm.showGame.name))]),_c('GameAbout',{attrs:{"datas":_vm.showGame,"opts":''},on:{"events":_vm.gameEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }